import Button from '@components/Button';
import { CancelGiftOrderRequest } from '@models/gift';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

function RefundButton({ giftItemType, giftBoxItemId }:CancelGiftOrderRequest) {
    const { push } = useFlow();
    const { t } = useTranslation('gift');
    const confirmCancel = () => {
        push('GiftCancelModal', { giftItemType, giftBoxItemId });
    };
    return (
        <Button fullWidth
            onClick={confirmCancel}>
            {t('giftSent.cancelPayment')}
        </Button>
    );
}

export default RefundButton;
